import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { ChatAttribute, SingleChatResponse } from 'types/Chats/Chat';

type MutationVariables = Partial<ChatAttribute>;

export function useUpdateChat(chatID: string | undefined | null) {
  const queryClient = useQueryClient();

  const updateChat = (updatedChat: MutationVariables) => {
    if (!chatID) {
      return Promise.reject('Chat ID cannot be null');
    }

    const body = {
      data: {
        id: chatID,
        type: SPARK_RESOURCE_TYPES.CHATS,
        attributes: updatedChat,
      },
    };

    const url = generateURL(SPARK_RESOURCE_TYPES.CHATS, [], chatID);
    return fetchWrapper<SingleChatResponse>({
      url: url,
      method: 'PATCH',
      body: body,
    });
  };

  return useMutation('updateChat', updateChat, {
    onSuccess: (data) => {
      const isDeleted = data.data.attributes.isDeleted;
      if (!isDeleted) {
        queryClient.invalidateQueries(['chats']);
      }
      toastr.success('Chat Updated');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to update Chat: ${error.message}`);
      }
    },
  });
}
